/* Product Tile Markup - You can play around with this to change the
information that appears on the Wishlisted Product tiles  */
/* REFERENCE: https://swym.it/help/how-to-render-a-custom-wishlist-on-an-existing-page/
              https://swym.it/help/build-your-own-wishlist-page/
              https://api-docs.swym.it/v3/index.html
*/
var atc_icon = 
  `<svg class="icon icon-cart" aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" viewBox="-1 -3 30 30" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
    <circle cx="9" cy="21" r="2"></circle>
    <circle cx="20" cy="21" r="2"></circle>
    <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
  </svg>`;
var productCardMarkup = 
///*
        `{{#products}}
        <li class="grid__item">
          <div class="card-wrapper underline-links-hover">
            <div class="card
              card--card
              card--media"
              style="--ratio-percent: 100.0%;"
            >
              <div class="card__inner color-background-1 gradient ratio" style="--ratio-percent: 100.0%;">
                <div class="card__media">
                  <div class="media media--transparent media--hover-effect">
                    <img
                      srcset="{{iu}}&width=165 165w, {{iu}}&width=360 360w, {{iu}}&width=533 533w, {{iu}}&width=600 600w, {{iu}} 620w"
                      src="{{iu}}"
                      sizes="(min-width: 1000px) 217px, (min-width: 990px) calc((100vw - 130px) / 4), (min-width: 750px) calc((100vw - 120px) / 3), calc((100vw - 35px) / 2)"
                      alt="{{dt}} - {{vi}}"
                      class="motion-reduce"
                      width="600"
                      height="600"
                    >
                  </div> <!-- end of media -->
                </div> <!-- end of card media -->
                <div class="card__content"
                     onclick="this.parentElement.nextElementSibling.querySelector('a').click()"
                     onmousedown="if (event.which == 2 || event.button == 4) { event.preventDefault(); window.open(this.parentElement.nextElementSibling.querySelector('a').href, '_blank'); }"
                >
                  <div class="card__information">
                    <h3 class="card__heading">
                      <a href="{{du}}?variant={{epi}}" class="full-unstyled-link">
                        {{dt}} - {{vi}}
                      </a>
                    </h3>
                  </div> <!-- end of card information -->
                  <div class="card__badge bottom left">
                    <!--<span class="badge badge--bottom-left color-inverse{{^oos}} hidden{{/oos}}">Sold out</span>-->
                    <span class="badge badge--bottom-left color-accent-2{{^ops}} hidden{{/ops}}">Sale</span>
                  </div>
                </div <!-- end of card content -->
                <!-- WISHLIST REMOVE BUTTON -->
                  <div class="wishlist-button-wrapper">
                    <button id="swym-remove-productBtn" 
                            class="swym-delete-btn swym-nav swym-nav-1 swym-is-button swym-icon" 
                            aria-label="Remove item from wishlist: {{dt}} - {{vi}}"
                            data-variant-id="{{epi}}" 
                            data-product-id="{{empi}}" 
                    >
                    </button>
                  </div>
                <!-- /END WISHLIST REMOVE BUTTON -->
              </div> <!-- end of card inner -->
              <div class="card__content">
                <div class="card__information">
                  <h3 class="card__heading h5" id="title-{{empi}}-{{epi}}">
                    <a href="{{du}}?variant={{epi}}" class="full-unstyled-link">
                      {{dt}} - {{vi}}
                    </a>
                  </h3>
                  <div class="card-information">
                    <span class="visually-hidden">Vendor:</span>
                    <div class="caption-with-letter-spacing light">{{bt}}</div>

                    <div class="price{{#ops}} price--on-sale{{/ops}}">
                      <div class="price__container">
                        <div class="invisible-sizer">
                          <div class="price__regular">
                            <span class="price-item price-item--regular">
                              {{#oos}}<span class="badge badge--bottom-left color-inverse">Sold out</span>{{/oos}}
                              {{^oos}}{{cu}} {{pr}} USD{{/oos}}
                            </span>
                          </div>
                          <div class="price__sale">
                            <span>
                              <s class="price-item price-item--regular">{{cu}} {{op}} USD</s>
                            </span>
                            <br>
                            <span class="price-item price-item--sale price-item--last">
                              {{cu}} {{pr}} USD
                            </span>
                          </div>
                        </div> <!-- end of invisible sizer -->
                        <div class="price__regular">
                          <span class="price-item price-item--regular">
                            {{#oos}}<span class="badge badge--bottom-left color-inverse">Sold out</span>{{/oos}}
                            {{^oos}}{{cu}} {{pr}} USD{{/oos}}
                          </span>
                        </div>
                        <div class="price__sale">
                          <span>
                            <s class="price-item price-item--regular price-regular-container">{{cu}} {{op}} USD</s>
                          </span>
                          <br>
                          <span class="price-item price-item--sale price-item--last">
                            {{cu}} {{pr}} USD
                          </span>
                        </div>
                      </div> <!-- end of price container -->
                    </div> <!-- end of price -->
                  </div> <!-- end of card information -->
                </div> <!-- end of card information (parent) -->
              </div> <!-- end of card content -->
              {{^oos}}
                <!-- ADD TO CART BUTTON -->
                <button id="swym-custom-add-toCartBtn" data-state-cart="{{#isInCart}}swym-added{{/isInCart}}"
                        data-product-url="{{du}}?variant={{epi}}" data-variant-id="{{epi}}" data-product-id="{{empi}}" 
                        class="osf-flexible-oos swym-add-to-cart-btn swym-button swym-button-1 swym-is-button button"
                        {{#isInCart}}disabled="disabled"{{/isInCart}}
                >` + atc_icon + `</button>
              {{/oos}}
              {{#oos}}
                <!-- ORDERSIFY OUT OF STOCK NOTIFY RESTOCK NOTIFICATION BUTTON -->
                <div data-osf-type="oos" data-osf-oos-type="one" data-osf-id="{{empi}}" data-osf-variant="{{epi}}">
                  <button type="button" class="osf-flexible-oos button">` + envelope_icon + `</button>
                </div>
                <div class="hidden osf-product-json">{{json}}</div>
              {{/oos}}
            </div> <!-- end of card -->
          </div> <!-- end of card wrapper -->
        </li>
        {{/products}}`;
/*
  ADDED IN PLACE OF REGULAR PRICE FOR NO BADGES: "{{cu}} {{pr}} USD" REPLACED BY:
    {{#oos}}<span class="badge badge--bottom-left color-inverse">Sold out</span>{{/oos}}
    {{^oos}}{{cu}} {{pr}} USD{{/oos}}
  REPLACING CLASS so no "oos":
    class="swym-add-to-cart-btn swym-button swym-button-1 swym-is-button button button--full-width button--primary{{#oos}} color-background-2 swym-notify-btn{{/oos}}"
  REPLACING disabled status for notify buttons (removing the #oos tag), added class to same elem:
    {{#isInCart}}disabled="disabled"{{/isInCart}} {{#oos}}disabled="disabled"{{/oos}}
    {{#oos}} swym-osf-notify{{/oos}}
  REPLACING BUY BUTTON ENTIRELY (also added variable "atc_icon"), ORIGINAL:
    <!-- ADD TO CART BUTTON -->
    <button id="swym-custom-add-toCartBtn" data-state-cart="{{#isInCart}}swym-added{{/isInCart}}"
            data-product-url="{{du}}?variant={{epi}}" data-variant-id="{{epi}}" data-product-id="{{empi}}" 
            class="swym-add-to-cart-btn swym-button swym-button-1 swym-is-button button button--full-width button--primary{{#oos}} swym-osf-notify{{/oos}}"
            {{#isInCart}}disabled="disabled"{{/isInCart}}
    >
      {{^oos}}{{#isInCart}}Added to cart{{/isInCart}}{{^isInCart}}Add to cart{{/isInCart}}{{/oos}}{{#oos}}Notify me{{/oos}}
    </button>
*/
//*/
/*
`<div class="swym-wishlist-grid">
   {{#products}} 
   <a href="{{du}}" aria-label="{{dt}}" class="swym-wishlist-item swym-is-anchor">
     <button id="swym-remove-productBtn" aria-label="Delete" data-variant-id="{{epi}}" data-product-id="{{empi}}" class="swym-delete-btn swym-nav swym-nav-1 swym-is-button">
       <span class="swym-icon">
       </span>
     </button>
     <div class="swym-wishlist-image-wrapper">
       <img alt="" class="swym-wishlist-image" src="{{iu}}">
     </div>
     <button class="swym-is-button">
       <div class="swym-title swym-title-1">
         {{dt}}
       </div>
     </button>
     <div class="swym-variant-title swym-text swym-title-2 swym-variant-title-spacer">
       {{variantinfo}}
     </div>
     <div class="swym-product-price swym-text swym-text-1">
       <div class="swym-product-final-price swym-value">
         {{cu}}{{pr}}
       </div>
     </div>
     <button id="swym-custom-add-toCartBtn" data-state-cart="{{#isInCart}} swym-added{{/isInCart}}" data-product-url="{{du}}" data-variant-id="{{epi}}" data-product-id="{{empi}}" class="swym-add-to-cart-btn swym-button swym-button-1 swym-is-button swym-is-button">
       {{#isInCart}}Added to cart{{/isInCart}}{{^isInCart}}Add to cart{{/isInCart}}
     </button>
   </a>
   {{/products}}
</div>`;
*/

function getVariantInfo(variants) {
	try {
		let variantKeys = ((variants && variants != "[]") ? Object.keys(JSON.parse(variants)[0]) : []),
			variantinfo;
		if (variantKeys.length > 0) {
			variantinfo = variantKeys[0];
			if (variantinfo == "Default Title") {
				variantinfo = "";
			}
		} else {
			variantinfo = "";
		}
		return variantinfo;
	} catch (err) {
		return variants;
	}
}

function onAddToCartClick(e) {
	e.preventDefault();
	var productId = e.currentTarget.getAttribute("data-product-id");
	var variantId = e.currentTarget.getAttribute("data-variant-id");
	var du = e.target.getAttribute("data-product-url");
  //console.log(productId, variantId, du);
	e.target.innerHTML = //"Adding..";
                `<div class="loading-overlay__spinner">
                  <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 80 80" xmlns="http://www.w3.org/2000/svg">
                    <circle class="path" fill="none" stroke-width="10" cx="40" cy="40" r="30"></circle>
                  </svg>
                </div>`;
  /*
	window._swat.replayAddToCart({
		empi: productId,
		du: du
	}, variantId, function(c) {
		e.target.innerHTML = "Added to Cart";
		e.target.setAttribute("data-state-cart", "swym-added");
        e.target.setAttribute("disabled", "disabled"); //ADDED
		console.log("Successfully added product to cart.", c);
	}, function(e) {
		console.log(e);
        //ADDED + NOTE: above is console log for "variant is in stock" message for sold out??? items; use this for restock notification?
	});
  */

  //ADDED custom add function
  //change hidden form value 
  document.querySelector('.product-form input[name="id"]').value = variantId;
  if (document.querySelector(".product-form__buttons button").disabled) {
    //activate buy button if not active
    document.querySelector(".product-form__buttons button").disabled = false;
  }
  //click buy button or notify button
  if (!e.target.classList.contains("swym-osf-notify")) {
    //console.log("atc button", e.target.innerHTML);
    document.querySelector(".product-form__buttons button").click();
    setTimeout(function() {
      //e.target.innerHTML = "Added to Cart";
      e.target.innerHTML = atc_icon;
  	e.target.setAttribute("data-state-cart", "swym-added");
      e.target.setAttribute("disabled", "disabled");
      //console.log("Successfully added to cart.");
    }, 700);
  }
  /*
  else {
    console.log("notify button", e.target.innerHTML);
    setTimeout(function() {
      e.target.innerHTML = "Notify me";
    }, 700);
  }
  */
}

function onRemoveBtnClick(e) {
	e.preventDefault();
	var epi = +e.currentTarget.getAttribute("data-variant-id");
	var empi = +e.currentTarget.getAttribute("data-product-id");
	window._swat.fetch(function(products) {
		products.forEach(function(product) {
			if (epi && empi && product.epi == epi && product.empi == empi){
				window._swat.removeFromWishList(product, function() {
					if (!window.SwymCallbacks) {
						window.SwymCallbacks = [];
					}
					window.SwymCallbacks.push(swymRenderWishlist);
				});
			}
		});
	}); //ADDED semicolon + next section to update header counter
    setTimeout(swymWishlistCounterBubble, 400);
}

function swymRenderWishlist(swat) {
	// Get wishlist items
	swat.fetch(function(products) {
		//console.log(products); //console.log(products)
        var wishlistContentsContainer = document.getElementById("product-grid"); //document.getElementById("wishlist-items-container");
		var formattedWishlistedProducts = products.map(function(p) {
            //ADDED for sales/stock status
            swat.getProductDetails(
              p, //productObject, 
              function(resp) { //callbackFn, 
                //console.log(resp);
                var vari = resp.variants.find(e => {
                  if (e.id == p.epi) {
                    //console.log(e);
                    return e;
                  }
                });
                p.oos = vari.available ? false : true;
                p.ops = vari.compare_at_price ? true : false;
                if (p.ops) {
                  p.op = (vari.compare_at_price - Math.floor(vari.compare_at_price) > 0) ? vari.compare_at_price : vari.compare_at_price / 100;
                }
                //console.log("IN FUNCT: \noos:", p.oos, "\nop:", p.op, "\npr:", p.pr, "\n>:", p.ops);
                p.json = JSON.stringify(resp);
                //console.log(p);
              },
              function(err) { //errorFn);
                console.log(err);
              }
            );
            //console.log("oos:", p.oos, "\nop:", p.op, "\npr:", p.pr, "\n>:", p.ops);
            
			p = SwymUtils.formatProductPrice(p); // formats product price and adds currency to product Object
          	p.isInCart = _swat.platform.isInDeviceCart(p.epi) || (p.et == _swat.EventTypes.addToCart);
			p.variantinfo = (p.vi ? getVariantInfo(p.vi) : "");

          /*
            p.oos = getWishlistOOS(p.epi); //ADDED to track out of stock status
            //ADDED to track sale prices
            p.ops = getWishlistOP(p.epi);
            if (p.ops) {
              p.op = getWishlistOPnum(p.epi).toString(); 
            }
            */
          //console.log(p); //ADDED product info array log
			return p;
		});
      //console.log("FORMATTED: \n", formattedWishlistedProducts); //ADDED product info array log
      var tempProductCounter = 0; //ADDED TIMEOUT FUNCTION COUNTER
      var tempProductTimer = setInterval(function() { //ADDED TIMEOUT FUNCTION AROUND ORIGINAL CODE
        tempProductCounter += 100;
        if (tempProductCounter > 1000) {
          clearInterval(tempProductTimer);
          document.getElementById('prevent-img-jitter').remove();
        }
        
        //ORIGINAL CODE:
		var productCardsMarkup = SwymUtils.renderTemplateString(productCardMarkup, {
			products: formattedWishlistedProducts
		});
		if(wishlistContentsContainer){
			wishlistContentsContainer.innerHTML = productCardsMarkup;
			attachClickListeners();
		} else{
		  console.log("Container not found, Wishlist Page element not found");
		}

        //ADDED for empty wishlist
        //if(wishlistContentsContainer.children.length == 0) {
        if(formattedWishlistedProducts.length == 0) {
          document.getElementById("swym-empty-wishlist-container").classList.remove("hidden");
        }

        //ADDED for notify button/ordersify initialization
        try {
          window.ORDERSIFY_BIS.addFlexibleOOSButtons();
        }
        catch {
          console.log("Ordersify is loading");
        }
        generateCardOrdersify();
      }, 200);

        //ADDED to hide original wishlist //TODO delete?
        /*
        if(!document.querySelector(".swym-page-container").classList.contains("hidden")) {
          document.querySelector(".swym-page-container").classList.add("hidden");
        }
        */
        //document.querySelector(".swym-page-container").remove();
	});
}

function attachClickListeners() {
	var addToCartButtons = document.querySelectorAll("#swym-custom-add-toCartBtn");
	var removeBtns = document.querySelectorAll("#swym-remove-productBtn");
	//   Add to cart Btns
	for (var i = 0; i < addToCartButtons.length; i++) {
		addToCartButtons[i].addEventListener('click', onAddToCartClick, false);
	}
	//   Remove Buttons
	for (var k = 0; k < removeBtns.length; k++) {
		removeBtns[k].addEventListener('click', onRemoveBtnClick, false);
	}
	//console.log("Events attached!");
}

/* ADDED TO END / MOVED
if (!window.SwymCallbacks) {
	window.SwymCallbacks = [];
}
window.SwymCallbacks.push(swymRenderWishlist); /* Init Here */


/* ADDED CUSTOM JS / CUSTOM JAVASCRIPT / CUSTOM SCRIPT */
//functions for "more options" menu
function removeAllWishlistItems() {
  if (document.querySelector("#product-grid li.grid__item .swym-delete-btn")) {
    var myWishlistGrid = document.querySelectorAll("#product-grid li.grid__item .swym-delete-btn");
    //console.log("remove all:\n", myWishlistGrid);
    myWishlistGrid.forEach(elem => elem.click());
  }
  let removeAllTimer = setInterval(function() {
    if (!document.querySelector('.wishlist-count-bubble').classList.contains('hidden')) {
      swymWishlistCounterBubble();
    }
    else {
      clearInterval(removeAllTimer);
    }
  }, 200);
}

/*
//function for sale/sold out items
function wishlistExtraStatus() {
  var swymWishlistGrid, myWishlistGrid, wishlistTimer, priceTimer = [];
  wishlistTimer = setInterval(function() {
    if (document.querySelector(".swym-wishlist-grid a")) {
      clearInterval(wishlistTimer);
      
      swymWishlistGrid = document.querySelectorAll(".swym-wishlist-grid a");
      myWishlistGrid = document.querySelectorAll("#product-grid li.grid__item");
      //console.log(swymWishlistGrid);
      //console.log(myWishlistGrid);
      
      for (let i = 0; i < swymWishlistGrid.length; i++) {
        priceTimer[i] = setInterval(function() {
          let swymGridItem = swymWishlistGrid.item(i);
          let myGridItem = myWishlistGrid.item(i);

          //grab "original price" for sales items and put in own card
          //console.log(i + " item: " + swymGridItem.querySelector(".swym-product-final-price").outerHTML);
          if (swymGridItem.querySelector(".swym-product-final-price")) {
            //console.log("past if, clear timer, op: " + swymGridItem.querySelector(".swym-product-original-price").outerHTML);
            clearInterval(priceTimer[i]);
            if (swymGridItem.querySelector(".swym-product-original-price")) {
              myGridItem.querySelector(".price-regular-container").innerHTML = "$ " + swymGridItem.querySelector(".swym-product-original-price").innerHTML.slice(1) + " USD";
              myGridItem.querySelector(".price").classList.add("price--on-sale");
              myGridItem.querySelector(".card__badge").lastElementChild.classList.remove("hidden");
            }
          }

          //grab stock status for sold out items and put in own card
          if (swymGridItem.querySelector(".swym-add-to-cart-btn").innerHTML == "Sold Out") {
            //console.log(swymGridItem.querySelector(".swym-add-to-cart-btn").innerHTML);
            myGridItem.querySelector(".card__badge").firstElementChild.classList.remove("hidden");
            myGridItem.querySelector(".swym-add-to-cart-btn").classList.add("color-background-2","swym-notify-btn");
            myGridItem.querySelector(".swym-add-to-cart-btn").innerHTML = "Notify me";
          }
          //replace add with restock notification button in "onAddToCartClick" listener?
        }, 100);
      }
    }
  }, 100);
}
//wishlistExtraStatus();
*/
/*
//in case of no cache/local storage
function wishlistTrackStatus() {
  var swymWishlistGrid, myWishlistGrid, wishlistTimer, priceTimer = [];
  wishlistTimer = setInterval(function() {
    if ((document.querySelector(".swym-wishlist-grid a") && document.querySelector("#product-grid li.grid__item"))
        || document.querySelector(".swym-empty-wishlist-container")
       ) {
      clearInterval(wishlistTimer);

      if (!document.querySelector(".swym-empty-wishlist-container")) {
        swymWishlistGrid = document.querySelectorAll(".swym-wishlist-grid a");
        myWishlistGrid = document.querySelectorAll("#product-grid li.grid__item");
        //console.log(swymWishlistGrid);
        //console.log(myWishlistGrid);
        
        for (let i = 0; i < swymWishlistGrid.length; i++) {
          priceTimer[i] = setInterval(function() {
            let swymGridItem = swymWishlistGrid.item(i);
            let myGridItem = myWishlistGrid.item(i);
            let variantId = myGridItem.querySelector(".swym-add-to-cart-btn").dataset.variantId;
  
            //grab "original price" for sales items and put in own card
            //console.log(i + " item: " + swymGridItem.querySelector(".swym-product-final-price").outerHTML);
            if (swymGridItem.querySelector(".swym-product-final-price")) {
              //console.log("past if, clear timer, op: " + swymGridItem.querySelector(".swym-product-original-price").outerHTML);
              clearInterval(priceTimer[i]);
              if (swymGridItem.querySelector(".swym-product-original-price")) {
                let op = swymGridItem.querySelector(".swym-product-original-price").innerHTML.slice(1).replace(".", "");
                //console.log("variantId: " + variantId, "\nop: " + op);
                setWishlistOP(variantId, op, true);
              }
            }
  
            //grab stock status for sold out items and put in own card
            if (swymGridItem.querySelector(".swym-add-to-cart-btn").innerHTML == "Sold Out") {
              //console.log(swymGridItem.querySelector(".swym-add-to-cart-btn").innerHTML);
              //console.log("variantId: " + variantId, "\noos:" + true);
              setWishlistOOS(variantId, true);
            }
          }, 100);
        }
      }

      var wishlistTimerCounter = 0;
      wishlistTimer = setInterval(function() {
        wishlistTimerCounter += 500;
        if (wishlistTimerCounter > 3000) {
          clearInterval(wishlistTimer);
        }
        if (!window.SwymCallbacks) {
        	window.SwymCallbacks = [];
        }
        window.SwymCallbacks.push(swymRenderWishlist);
      }, 500);
      
      //move user button from original list //TODO: REPLACE WITH HIDE?
      //saveListButtonFn();
      //hide original wishlist
      if (document.querySelector(".swym-page-container")) {
        //document.querySelector(".swym-page-container").remove(); // TODO ADD BACK IN
      }
    }
  }, 100);
}
wishlistTrackStatus();
*/

//save original "save list" button //TODO: DELETE FUNCTION?
function saveListButtonFn() {
  var timerSL = setInterval(function() {
    if (document.querySelector(".swym-user-login-status")) {
      clearInterval(timerSL);
      //move node from original place to hidden container
      document.querySelector(".hidden-swym-user-button-container").appendChild(document.querySelector(".swym-user-login-status"));

      //hide original wishlist
      if (document.querySelector(".swym-page-container")) {
        document.querySelector(".swym-page-container").remove();
      }
    }
  }, 100);
}

//save scroll bar size to root css //TODO: move to "global.js" or similar!
/*
function updateScrollbarWidth() {
  let timerCounter = 0;
  var timerScrollbar = setInterval(function() {
    timerCounter += 200;
    let scrollbarWidth = window.clientWidth; //TODO: added this to error catch below, need to double check actual page to see if it worked!
    if (document.body) {
      let scrollbarWidth = window.innerWidth - document.body.clientWidth;
    }
    //console.log(window.innerWidth, document.body.clientWidth, scrollbarWidth);
    document.documentElement.style.setProperty('--modal-page-padding', scrollbarWidth + 'px');
    if (timerCounter > 3000) {
      clearInterval(timerScrollbar);
    }
  }, 200);
}
updateScrollbarWidth();
function updateScrollbarHeight() {
  var timerScrollbar = setInterval(function() {
    if (document.querySelector("#Wishlist-Modal-Info[open]")) {
      clearInterval(timerScrollbar);
      var scrollbarHeight = document.querySelector('.custom-wishlist-modal').offsetHeight + 150; //100 margin on top, 50 bottom just in case
      //console.log(scrollbarHeight, " > ", window.innerHeight, "?");
      scrollbarHeight = scrollbarHeight - window.innerHeight;
      setTimeout(function() {
        if (scrollbarHeight > 0) {
          //console.log('positive height = modal window larger than client, >0: ', scrollbarHeight);
          document.documentElement.style.setProperty('--modal-page-stretch', 'calc(' + (-1 * scrollbarHeight) + 'px - 15rem)');
        }
        else {
          //console.log('negative height = modal window smaller than client, setting to 20, <0: ', scrollbarHeight);
          document.documentElement.style.setProperty('--modal-page-stretch', '20rem');
        }
      }, 300);
    }
  }, 300);
}
*/

//hide first modal screen and open second one
function openModalScreen(hideElem, openElem) {
  //console.log("in openSecondModal(), hideElem: ", typeof hideElem, hideElem, ", openElem: ", typeof openElem, openElem);
  //removed "swym-modal-active" from "body" tag on click (done via CSS, see "page.swym.liquid")?
  document.querySelector(".custom-wishlist-modal ." + hideElem).classList.add("hidden");
  document.querySelector(".custom-wishlist-modal ." + openElem).classList.remove("hidden");
  //updateScrollbarHeight();
}

//check if inputted email is valid //TODO: move to "global.js" or similar!
function checkValidEmail(str) {
  //validate email
  //REF: https://www.simplilearn.com/tutorials/javascript-tutorial/email-validation-in-javascript
  //var validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
  //if (emailInput.value.match(validRegex)) {
  //REF: https://stackoverflow.com/questions/46155/how-can-i-validate-an-email-address-in-javascript
  //var validRegex = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+(?:[A-Z]{2}|com|org|net|gov|mil|biz|info|mobi|name|aero|jobs|museum)\b/;
  //REF: http://zparacha.com/validate-email-address-using-javascript-regular-expression
  //var validRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
  var validRegex = /^[a-zA-Z0-9._\+-]+@[a-zA-Z0-9._\+-]+\.[a-zA-Z]{2,18}$/;
  if (validRegex.test(str)) {
    //alert("Valid email address!");
    //hide error message
    document.querySelector(".custom-wishlist-modal .custom-modal-error-msg").classList.add("error-msg-hidden");
    return true;
  }
  else {
    //alert("Invalid email address!");
    //display error message
    let errorMsg = document.querySelector(".custom-wishlist-modal .custom-modal-error-msg");
    errorMsg.classList.remove("error-msg-hidden");
    if (!errorMsg.classList.contains("showError")) {
      errorMsg.classList.add("showError");
    }
    else { //contains "showError"
      errorMsg.classList.add("errorTimer");
    }
    setTimeout(function() {
      if (!errorMsg.classList.contains("errorTimer")) {
        errorMsg.classList.add("error-msg-hidden");
        errorMsg.classList.remove("showError");
      }
      else { //contains "errorTimer"
        errorMsg.classList.remove("errorTimer");
      }
    }, 3000);
    return false;
  }
}

//send "save list" info
function submitSaveList() {
  //validate email
  var emailInput = document.querySelector(".custom-wishlist-modal #swym_save_list_form_email");
  if (checkValidEmail(emailInput.value)) {
    //console.log("valid email");
    //emailInput.focus();

    /*
    if (!document.querySelector("#swym-email")) {
      document.querySelector(".swym-user-login-status").click();
    }
    var timerSL = setInterval(function() {
      if (document.querySelector(".swym-save-list-btn")) {
        clearInterval(timerSL);
        document.querySelector(".swym-save-list-btn").click();
        timerSL = setInterval(function() {
          if (document.querySelector("#swym-email")) {
            clearInterval(timerSL);
            document.querySelector("#swym-first-name").value = document.querySelector(".custom-wishlist-modal #swym_save_list_form_name").value;
            document.querySelector("#swym-last-name").value = document.querySelector(".custom-wishlist-modal #swym_save_list_form_surname").value;
            document.querySelector("#swym-email").value = document.querySelector(".custom-wishlist-modal #swym_save_list_form_email").value;

            //activate native swym event listeners
            var evt = document.createEvent("Events");
            evt.initEvent("input", true, true);
            document.querySelector("#swym-email").dispatchEvent(evt);

            timerSL = setInterval(function() {
              if (!document.querySelector(".swym-save-list-btn").classList.contains("swym-disabled")) {
                clearInterval(timerSL);
                document.querySelector(".swym-save-list-btn").click();
                openModalScreen('custom-modal-content-save-list-2','custom-modal-content-save-list-3');
              }
            }, 100);
          }
        }, 100);
      }
    }, 100);
    */
    window._swat.remoteAuthRequest(
      function(resp) { 
        //console.log(resp); 
        openModalScreen('custom-modal-content-save-list-2','custom-modal-content-save-list-3');
      },
      function(err) { 
        //console.log(err); 
        openModalScreen('custom-modal-content-save-list-2','custom-modal-content-save-list-4');
      },
      document.querySelector(".custom-wishlist-modal #swym_save_list_form_email").value
    );
  } else {
    //console.log("invalid email");
    emailInput.focus();
    //display error message in validate email function
  }
}
//retrieve "save list" info
function fetchSaveList() {
  //validate email
  var emailInput = document.querySelector(".custom-wishlist-modal #swym_fetch_list_form_email");
  if (checkValidEmail(emailInput.value)) {
    //console.log("valid email");
    //emailInput.focus();
    
    console.log(window._swat.pid, window._swat, window._swat.api);
    /*
    var token_; // variable will store the token
    var userName = window._swat.pid; // app clientID
    var passWord = "secretKey"; // app clientSecret (API KEY)
    var apiUrl = "https://swymstore-v3free-01.swymrelay.com/storeadmin/user/wishlist?"; // Your application token endpoint  
    var request = new XMLHttpRequest(); 
    var key;           
    request.open("GET", apiUrl, true); 
    request.setRequestHeader("Authorization", "Basic BASE64-ENCODING-OF-" + userName + ":" + passWord);
    request.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
    request.send("useremail=" + emailInput.value); // specify the credentials to receive the token on request
    request.onreadystatechange = function () {
        if (request.readyState == request.DONE) {
            var response = request.responseText;
              console.log(response);
            //var obj = JSON.parse(response); 
            //key = obj.access_token; //store the value of the accesstoken
            //token_ = key; // store token in your global variable "token_" or you could simply return the value of the access token from the function
            //console.log(obj, key);
        }
    }
    */
    
    /*
    var params = {
      skipConnect: true
    };
    window._swat.saveShopperContext(
      emailInput.value, 
      params, 
      function(resp) { //successCallback, 
        console.log("saveShopperContext success", resp);
      },
      function(err) { //errorCallback
        console.log("saveShopperContext failed", err);
      }
    );
    */
  } else {
    //console.log("invalid email");
    emailInput.focus();
    //display error message in validate email function
  }
}

//check if logged in
function swymLogin() {
  var loginTimer = setInterval(function() {
    if (window._swat) {
      clearInterval(loginTimer);
      window._swat.authCheck(
        function(r) {
          //console.log(r);
          if (r.authn) {
            //change user button and modal
            if (document.querySelector(".swym-user-container .swym-options-item-btn")) {
              if (document.querySelector(".swym-user-container .swym-options-item-btn").innerHTML == "Guest Shopper") {
                document.querySelector(".swym-user-container .swym-options-item-btn").innerHTML = r.email;
                document.querySelector(".swym-user-container .swym-user-login-name").innerHTML = r.email;
                //change share list login info
                if (document.getElementById("swym-share-list-name")) {
                  document.getElementById("swym-share-list-name").innerHTML = r.email;
                }
              }
            }
            //automate save list email input/error message login name
            if (document.getElementById("swym_save_list_form_email")) {
              document.getElementById("swym_save_list_form_email").setAttribute("value", r.email);
              document.getElementById("swym-save-login-name").innerHTML = r.email;
            }
            //automate share list email input
            if (document.getElementById("swym_share_list_form_from_email")) {
              document.getElementById("swym_share_list_form_from_email").setAttribute("value", r.email);
              document.getElementById("swym_share_list_form_from_email").disabled = true;
            }
          }
          else {
            //disable disconnect button
            if (document.getElementById("fetch_list_disconnect_button")) {
              document.getElementById("fetch_list_disconnect_button").disabled = true;
            }
            //change share list info
            if (document.getElementById("swym-share-list-optional")) {
              document.getElementById("swym-share-list-optional").classList.remove("hidden");
            }
            //disable share wishlist via url generation button
            document.getElementById("swym-send-via-url-btn").disabled = true;
          }
        }
      );
    }
  }, 100);
}
swymLogin();

/*
//swym account disconnect/logout
function swymLogout() {
  //console.log("in swymLogout()");
  window._swat.disconnectShopperContext(
    function(resp) { //successCallback, 
      //console.log("Wishlist logout success", resp);
      window.location.reload();
    },
    function(err) { //errorFn
      console.log("Wishlist logout failed", err);
    }
  );
}
*/
//MOVED TO MAIN "swym-custom.liquid" JS SECTION

//share list via email
function shareWishlistViaEmail() {
  //var fromName = document.querySelector(".custom-wishlist-modal #swym_share_list_form_name").value;
  var emailId = document.querySelector(".custom-wishlist-modal #swym_share_list_form_to_email").value;
  var fromEmailId = document.querySelector(".custom-wishlist-modal #swym_share_list_form_from_email").value;
  var noteTxt = document.querySelector(".custom-wishlist-modal #swym_share_list_form_comment").value;

  if (checkValidEmail(emailId) && checkValidEmail(fromEmailId) && document.querySelector("#swym-empty-wishlist-container").classList.contains("hidden")) {
    if (document.querySelector(".swym-user-container .swym-options-item-btn").innerHTML == "Guest Shopper") {
      window._swat.sendEmailWishList(function callback() {
         // Successfully sent
        //console.log("successfully sent to: ", emailId, fromEmailId, noteTxt);
        document.querySelector('.custom-wishlist-modal .swym-sent-to-name').innerHTML = emailId;
        openModalScreen('custom-modal-content-share-list-2','custom-modal-content-share-list-3');
        document.querySelector(".custom-wishlist-modal #swym_share_list_form_to_email").value = "";
      }, emailId, fromEmailId, noteTxt);
    }
    else {
      window._swat.sendListViaEmail(
        {
         toEmailId: emailId,
         //fromName: fromName,
         fromName: fromEmailId,
         note: noteTxt,
         lid: null, // null when multiple list is not enabled
         cprops: {}, // custom props for the share, future usage
        },
        function(r) {
          //console.log('Email sent!');
          //console.log(r);
          document.querySelector('.custom-wishlist-modal .swym-sent-to-name').innerHTML = emailId;
          openModalScreen('custom-modal-content-share-list-2','custom-modal-content-share-list-3');
          document.querySelector(".custom-wishlist-modal #swym_share_list_form_to_email").value = "";
        },
        function(r) {
          //console.log('Email failed!', r);
          openModalScreen('custom-modal-content-share-list-2','custom-modal-content-share-list-4');
        }
      );
    }
  } else {
    //console.log("invalid email");
    if (!checkValidEmail(fromEmailId)) {
      document.querySelector(".custom-wishlist-modal #swym_share_list_form_from_email").focus();
    }
    else if (!checkValidEmail(emailId)) {
      document.querySelector(".custom-wishlist-modal #swym_share_list_form_to_email").focus();
    }
    //display error message in validate email function

      //if wishlist is empty, error message
    else if (!document.querySelector("#swym-empty-wishlist-container").classList.contains("hidden")) {
      openModalScreen('custom-modal-content-share-list-2','custom-modal-content-share-list-6');
    }
  }
}
//share wishlist via URL (assuming user is already authenticated)
var swymGeneratedURL;
function shareWishlistViaURL(modalOpen) {
  if (!swymGeneratedURL) {
    window._swat.generateSharedListURL( //listId, callbackFn, errCallBack
      null,
      function(data, sharedListId) {
        //console.log(data, sharedListId);
        swymGeneratedURL = data;
      },     // returns the generated url
      function(data) {
        //console.log("ERROR:", data);
      }
    );
    //console.log("returned URL:", swymGeneratedURL);
  }

  //fill modal input field
  if (modalOpen) {
    if (!document.querySelector("#swym-empty-wishlist-container").classList.contains("hidden")) {
      openModalScreen('custom-modal-content-share-list-1','custom-modal-content-share-list-6');
    }
    else if (swymGeneratedURL) {
      document.querySelector(".custom-wishlist-modal #swym_share_list_form_url").value = swymGeneratedURL;
      openModalScreen('custom-modal-content-share-list-1','custom-modal-content-share-list-5');
    }
    else {
      var generatorTimer = setInterval(function() {
        if (swymGeneratedURL) {
          clearInterval(generatorTimer);
          document.querySelector(".custom-wishlist-modal #swym_share_list_form_url").value = swymGeneratedURL;
          openModalScreen('custom-modal-content-share-list-1','custom-modal-content-share-list-5');
        }
      }, 100);
    }
  }
}
function copyGeneratedURL() {
  document.querySelector(".custom-wishlist-modal #swym_share_list_form_url").select();
  document.execCommand("copy");
  //display copy message
  let copyMsg = document.querySelector(".custom-wishlist-modal .custom-modal-success-msg");
  copyMsg.classList.remove("success-msg-hidden");
  if (!copyMsg.classList.contains("showCopyMsg")) {
    copyMsg.classList.add("showCopyMsg");
  }
  else { //contains "showCopyMsg"
    copyMsg.classList.add("copyTimer");
  }
  setTimeout(function() {
    if (!copyMsg.classList.contains("copyTimer")) {
      copyMsg.classList.add("success-msg-hidden");
      copyMsg.classList.remove("showCopyMsg");
    }
    else { //contains "copyTimer"
      copyMsg.classList.remove("copyTimer");
    }
  }, 3000);
}

//link notify buttons (using ORDERSIFY) //TO DELETE - use ordersify's flexibleOOS function and generateCardOrdersify function instead
function swymNotifyButtons(swat) {
  window.ORDERSIFY_BIS.collection_products = [];
  setTimeout(function() {
    // Get wishlist items
    swat.fetch(function(products) {
      //console.log(products);
      var formattedWishlistedProducts = products.map(function(p) {
        swat.getProductDetails(
          p, //productObject, 
          function(resp) { //callbackFn, 
            //console.log(resp);
            var vari = resp.variants.find(e => {
              if (e.id == p.epi) {
                //console.log(e);
                return e;
              }
            });
            window.ORDERSIFY_BIS.collection_products.push(vari);
          },
          function(err) { //errorFn);
            console.log(err);
          }
        );
        return p;
      });
    });
    //console.log(window.ORDERSIFY_BIS.collection_products);
  }, 1000);
}
//window.SwymCallbacks.push(swymNotifyButtons);

/*
//render shared wishlist
function swymRenderSharedWishlist(swat) {
  var queryParams = swat.utils.getEncodedAsObject(window.location.search);
  var sharedHkey = queryParams["hkey"] || queryParams["lid"];
  var sharedWishlistContainerElement = document.querySelector("#swym-custom-shared-wishlist-container");
  swat.ui.renderSharedWishlistInContainer(sharedWishlistContainerElement, sharedHkey, queryParams);
}
if (!window.SwymCallbacks) {
	window.SwymCallbacks = [];
}
window.SwymCallbacks.push(swymRenderSharedWishlist);
*/

//CUSTOM RENDER SHARED WISHLIST ITEMS, REF: https://docs.google.com/document/d/1g2rlsZlewmx2PFUk-IhIyokcvco9EVOWQUd-lxm0o7k/edit
function fetchSharedWishlistProducts(swat) {
  //console.log("in fetchSharedWishlistProducts()");
	//   Get the Hkey
	var userHkey = SwymUtils.getParameterByName("hkey");
  //console.log('"' + userHkey + '"\n', userHkey.length, '"' + userHkey.trim() + '"\n');
    if (userHkey && userHkey.length > 0 && userHkey.trim() !== "") {
    	_swat.sharedWlApi.fetch({
			params: {
				hkey: userHkey
			},
			scb: function(res) { //successCallback
              //console.log("successCallback", res);
				//renderWishlistUI(res.queryres, userHkey); // Render the Products in the User Interface.
              var products = res.queryres;
              //fetch the container.
              var wishlistContentsContainer = document.getElementById("product-grid"); //document.getElementById("swym-custom-shared-wishlist-container");
              //   format products if required
              var formattedWishlistedProducts = products.map(function(p) {
                  //p = SwymUtils.formatProductPrice(p); // formats product price and adds currency to product Object
                //console.log(p);
                p.dt = p.title;
                p.vi = p.vval1;
                p.du = p.uri.split('?')[0];
                p.oos = p.iqty > 0 ? false : true;
                //ADDED for sales status
                swat.getProductDetails(
                  p, //productObject, 
                  function(resp) { //callbackFn, 
                    //console.log(resp);
                    var vari = resp.variants.find(e => {
                      if (e.id == p.epi) {
                        //console.log(e);
                        return e;
                      }
                    });
                    p.ops = vari.compare_at_price ? true : false;
                    if (p.ops) {
                      p.op = (vari.compare_at_price - Math.floor(vari.compare_at_price) > 0) ? vari.compare_at_price : vari.compare_at_price / 100;
                    }
                    //console.log("IN FUNCT: \noos:", p.oos, "\nop:", p.op, "\npr:", p.pr, "\n>:", p.ops);
                    p.json = JSON.stringify(resp);
                    //console.log(p);
                  },
                  function(err) { //errorFn);
                    console.log(err);
                  }
                );
                //console.log("oos:", p.oos, "\nop:", p.op, "\npr:", p.pr, "\n>:", p.ops);
                
    			p = SwymUtils.formatProductPrice(p); // formats product price and adds currency to product Object
              	p.isInCart = _swat.platform.isInDeviceCart(p.epi) || (p.et == _swat.EventTypes.addToCart);
    			p.variantinfo = (p.vi ? getVariantInfo(p.vi) : "");
                  return p;
              });
              var tempProductCounter = 0; //ADDED TIMEOUT FUNCTION COUNTER
              var tempProductTimer = setInterval(function() { //ADDED TIMEOUT FUNCTION AROUND ORIGINAL CODE
                tempProductCounter += 100;
                if (tempProductCounter > 1000) {
                  clearInterval(tempProductTimer);
                  document.getElementById('prevent-img-jitter').remove();
                }
                
                //ORIGINAL CODE:
                // final shared products output.   
                var sharedProducts = {
                    //productArray: formattedWishlistedProducts,
                    products: formattedWishlistedProducts,
                    hkey: userHkey
                };
                //render the page using mustache.
                var productCardsMarkup = Mustache.render(productCardMarkup, sharedProducts);
                //wishlistContentsContainer.innerHTML = productCardsMarkup;
                //ADDED if statement to catch errors
        		if(wishlistContentsContainer){
        			wishlistContentsContainer.innerHTML = productCardsMarkup;
        			attachClickListeners();
        		} else{
        		  console.log("Container not found, Wishlist Page element not found");
        		}
                
                //remove "delete" buttons since this is a read-only list, and change header info
                if (document.querySelector(".wishlist-button-wrapper")) {
                  document.querySelectorAll(".wishlist-button-wrapper").forEach(elem => {
                    elem.remove();
                  });
                }
                /*
                if (document.querySelector(".swym-options-container")) {
                  document.querySelector(".swym-options-container").remove();
                }
                document.querySelector(".collection-hero__title").innerHTML = "Shared Wishlist";
                document.querySelector("#swym-shared-list-info-container").classList.remove("hidden");
                */

                //change shared wishlist user email
                //document.querySelector("#swym-shared-list-info-email").innerHTML = res.querystr.email;
                
                //ADDED for notify button/ordersify initialization
                try {
                  window.ORDERSIFY_BIS.addFlexibleOOSButtons();
                }
                catch {
                  console.log("Ordersify is loading");
                }
                generateCardOrdersify();
              }, 200);
			},
			fcb: function() { //errorCallback
              //console.log("errorCallback");
				SwymUtils.error("Error fetching shared wishlisted Products", arguments);
			}
		});
	}
}
if (!window.SwymCallbacks) {
	window.SwymCallbacks = [];
}
//if (window.location.href.includes("swym-share-wishlist")) {
if (window.location.href.includes("shared-wishlist")) {
  //console.log("pushing fetchSharedWishlistProducts");
  if (document.querySelector(".swym-options-container")) {
    document.querySelector(".swym-options-container").remove();
  }
  document.querySelector(".collection-hero__title").innerHTML = "Shared Wishlist";
  document.querySelector("#swym-shared-list-info-container").classList.remove("hidden");
window.SwymCallbacks.push(fetchSharedWishlistProducts);
}
else {
  //console.log("pushing swymRenderWishlist");
window.SwymCallbacks.push(swymRenderWishlist);
}